// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  },
};

(function () {
  BoostPFS.inject(this);

  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
    var itemHtml = "";
    var priceTax = window.theme.product_tax
      ? ((this.data.price_min * window.theme.product_tax) / 5) * 5
      : this.data.price_min;

    itemHtml +=
      '<li class="boost-pfs-search-suggestion-item pinned-item boost-pfs-search-suggestion-item-product boost-pfs-ui-item ui-menu-item" aria-label="' +
      this.title +
      '" data-id="' +
      this.id +
      '" >';
    itemHtml += '<a href="' + this.url + '" tabindex="-1" class="ui-menu-item-wrapper">';
    itemHtml +=
      '<div class="boost-pfs-search-suggestion-left"><img src="' +
      this.imageUrl +
      '" alt="' +
      this.title +
      '"></div>';
    itemHtml += '<div class="boost-pfs-search-suggestion-right">';
    itemHtml += '<p class="boost-pfs-search-suggestion-product-title">' + this.title + "</p>";
    itemHtml += '<p class="boost-pfs-search-suggestion-product-sku">SKU: ' + this.sku + "</p>";
    itemHtml +=
      '<p class="boost-pfs-search-suggestion-product-price"><span class="boost-pfs-search-suggestion-product-regular-price">' +
      Utils.formatMoney(priceTax, theme.moneyWithFormat) +
      "</span></p>";
    itemHtml += "</div></a></li>";
    return itemHtml;
  };
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
    var totalProduct = 0;
    var totalPages = 0;
    var query = "";
    if (this.instantSearchResult.data) {
      this.instantSearchResult.data.forEach(function (value) {
        if (value.key == "query") {
          query = value.values;
        }
      });

      this.instantSearchResult.data.forEach(function (value) {
        // console.log('value')
        // console.log(value)
        if (value.key == "total_product") {
          totalProduct = value.values;
          $("body")
            .find(".boost-pfs-search-suggestion-header-products.boost-pfs-search-suggestion-header")
            .html("Products  |  " + value.values + " Results");
          $("body")
            .find('.boost-pfs-search-suggestion-mobile [data-group="products"]')
            .prepend(
              '<p class="boost-pfs-search-suggestion-header-products boost-pfs-search-suggestion-header">Products  |  ' +
                value.values +
                " Results</p>"
            );

          if (value.values < 6) {
            $(".boost-pfs-search-suggestion-header-view-all").css("display", "none");
          }
          if (value.values < 1) {
            var searchValue = $("#boost-pfs-search-box-0").val();
            if (window.innerWidth < 760) {
              searchValue = $("#boost-pfs-search-box-mobile").val();
            }
            var noResultsHtml = '<div class="products-group w-full sm:pr-0 mb-3-6 sm:mb-0">';
            noResultsHtml +=
              '<p class="font-heading font-medium text-xxs sm:text-tiny text-body leading-lg border-b-1 border-grey-10 uppercase pb-0-8 sm:pb-1">Products  |  0 Results</p>';
            noResultsHtml +=
              '<p class="text-xs sm:text-xxs leading-loose text-body pt-0-6">We found no products for ‘' +
              query +
              "’</p>";
            noResultsHtml += "</div>";
            $("body").find('[data-group="pages"]').parent().prepend(noResultsHtml);
            $("body")
              .find('.boost-pfs-search-suggestion-group[data-group="products"]')
              .css("display", "none");
          }
        }
        if (value.key == "pages") {
          totalPages = value.values.length;
          $("body")
            .find(".boost-pfs-search-suggestion-header-pages.boost-pfs-search-suggestion-header")
            .html("Pages  |  " + value.values.length + " Results");
          if (value.values.length < 1) {
            var noResultsHtml = '<div class="pages-group w-full sm:w-1/4 sm:pl-2-4">';
            noResultsHtml +=
              '<p class="font-heading font-medium text-xxs sm:text-tiny text-body leading-lg border-b-1 border-grey-10 uppercase pb-0-8 sm:pb-1">Pages  |  0 Results</p>';
            noResultsHtml += "</div>";
            $("body").find('[data-group="products"]').parent().append(noResultsHtml);
          }
        }
        if (value.key == "all_empty") {
          if (value.values) {
            var resultsMessage = $("body")
              .find(".boost-pfs-search-suggestion-no-result span")
              .text();
            var searchValue = $("#boost-pfs-search-box-0").val();
            if (window.innerWidth < 760) {
              searchValue = $("#boost-pfs-search-box-mobile").val();
            }
            var noResultsHtml =
              '<div class="search-no-reults flex flex-col sm:flex-row flex-wrap">';
            noResultsHtml += '<div class="products-group w-full sm:pr-0 mb-3-6 sm:mb-0">';
            noResultsHtml +=
              '<p class="font-heading font-medium text-xxs sm:text-tiny text-body leading-lg border-b-1 border-grey-10 uppercase pb-0-8 sm:pb-1">Products  |  0 Results</p>';
            noResultsHtml +=
              '<p class="text-xs sm:text-xxs leading-lg sm:leading-loose text-body sm:pt-0-6 pt-0-6">We found no results for ‘' +
              query +
              "’</p>";
            noResultsHtml += "</div>";
            noResultsHtml += '<div class="pages-group w-full sm:w-1/4 sm:pl-2-4">';
            noResultsHtml +=
              '<p class="font-heading font-medium text-xxs sm:text-tiny text-body leading-lg border-b-1 border-grey-10 uppercase pb-0-8 sm:pb-1">Pages  |  0 Results</p>';
            noResultsHtml += "</div>";
            noResultsHtml += "</div>";
            $("body").find(".boost-pfs-search-suggestion-no-result").html(noResultsHtml);
          }
        }
        if (value.key == "products") {
          if (value.values.length > 0) {
            for (var j = 0; j < value.values.length; j++) {
              var item = value.values[j];
              if (item.metafields) {
                item.metafields.forEach(function (metafield) {
                  if (metafield.key == "short_description") {
                    $(
                      '<p class="text-xxs sm:text-tiny uppercase text-body tracking-md leading-m font-normal mb-0-4">' +
                        metafield.value +
                        "</p>"
                    ).insertAfter(
                      '[data-id="' + item.id + '"] .boost-pfs-search-suggestion-product-vendor'
                    );
                  }
                });
              }
            }
          }
        }
      });
      if (totalPages < 1 && totalProduct < 1) {
        var resultsMessage = $("body").find(".boost-pfs-search-suggestion-no-result span").text();
        var searchValue = $("#boost-pfs-search-box-0").val();
        if (window.innerWidth < 760) {
          searchValue = $("#boost-pfs-search-box-mobile").val();
        }
        var noResultsHtml =
          '<li class="w-full"><div class="search-no-reults flex flex-col sm:flex-row flex-wrap">';
        noResultsHtml += '<div class="products-group w-full sm:pr-0 mb-3-6 sm:mb-0">';
        noResultsHtml +=
          '<p class="font-heading font-medium text-xxs sm:text-tiny text-body leading-lg border-b-1 border-grey-10 uppercase pb-0-8 sm:pb-1">Products  |  0 Results</p>';
        noResultsHtml +=
          '<p class="text-xs sm:text-xxs leading-lg sm:leading-loose text-body sm:pt-0-6 pt-0-6">We found no results for ‘' +
          query +
          "’</p>";
        noResultsHtml += "</div>";
        noResultsHtml += '<div class="pages-group w-full sm:w-1/4 sm:pl-2-4">';
        noResultsHtml +=
          '<p class="font-heading font-medium text-xxs sm:text-tiny text-body leading-lg border-b-1 border-grey-10 uppercase pb-0-8 sm:pb-1">Pages  |  0 Results</p>';
        noResultsHtml += "</div>";
        noResultsHtml += "</div></li>";
        $("body").find(".boost-pfs-search-suggestion").html(noResultsHtml);
      }
    }
  };

  InstantSearchMobile.prototype.afterShowSearchBoxMobile = function (searchBoxId) {
    // console.log(searchBoxId);
  };
})();
